import request from '@/common/request'
import { AxiosRequestConfig } from 'axios'
import { DadosDeVendaProcessada } from '@/models'

const API_PATH = '/data/vendas'

export const dadosDeVendas = async (params?: any, config?: AxiosRequestConfig): Promise<DadosDeVendaProcessada[]> =>
	await request.get(`${API_PATH}`, {
		params: {
			...params,
			...params.page,
		},
		...config,
	})
